import React from 'react'
import { Pin } from '@vis.gl/react-google-maps'

/**
 * Centralized pin appearance for every "named location" marker in the app.
 * Anywhere a place or coords-only pin is shown — inline mini-map, location
 * detail modal, expanded overview, location picker, location viewer — the
 * pin uses these colors and the `<StandardPin>` wrapper. Highlight state
 * (currently used by the inline mini-map's chip↔pin selection) flips to
 * the amber variant.
 *
 * The unnamed-pin gray dot in PlacesCollectionPage is intentionally NOT
 * standardized here; it's a different semantic ("a coords-only attachment
 * with no Place row backing it") and looks different on purpose.
 */

export const PIN_COLORS = {
    bg: '#dc2626',
    border: '#7f1d1d',
    glyph: 'white',
    bgHighlight: '#f59e0b',
    borderHighlight: '#b45309',
} as const

interface StandardPinProps {
    highlighted?: boolean
}

/** Must be rendered inside an `<AdvancedMarker>` — `<Pin>` reads context
 *  from that ancestor and a console error fires otherwise. */
export const StandardPin: React.FC<StandardPinProps> = ({ highlighted }) => (
    <Pin
        background={highlighted ? PIN_COLORS.bgHighlight : PIN_COLORS.bg}
        borderColor={highlighted ? PIN_COLORS.borderHighlight : PIN_COLORS.border}
        glyphColor={PIN_COLORS.glyph}
    />
)
